import { useState, useEffect } from 'react';
import { USE_DEBOUNCE_TYPES } from '../constants/useDebounceTypes';

const { TRUTHY, FALSY, TRUTH_OR_FALSY } = USE_DEBOUNCE_TYPES;

export const useDebounce = (value, timeout, type = TRUTH_OR_FALSY) => {
  const [debouncedValue, setValue] = useState();

  const calculateTimeout = () => {
    const shouldHaveTimeout = type === TRUTH_OR_FALSY || (type === TRUTHY && !!value) || (type === FALSY && !value);
    if (!shouldHaveTimeout) {
      return 0;
    }

    return timeout;
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => setValue(value), calculateTimeout());

    return () => clearTimeout(timeoutId);
  }, [value]);

  return debouncedValue;
};
